"use client"

import Link from "next/link"
import { usePathname } from "next/navigation"

interface HeaderMobileNavigationProps {
    onItemClick: () => void
}

export function HeaderMobileNavigation({ onItemClick }: HeaderMobileNavigationProps) {
    const pathname = usePathname()

    const getNavItemClass = (page: string) => {
        const baseClass = "block px-6 sm:px-8 py-3 transition-colors duration-200 onest-nav"
        return pathname === page
            ? `${baseClass} text-gray-900 bg-gray-100 font-semibold`
            : `${baseClass} text-gray-700 hover:bg-gray-50`
    }

    return (
        <>
            <a
                href="/#how-it-works"
                className="block px-6 sm:px-8 py-3 text-gray-700 hover:bg-gray-50 transition-colors duration-200 onest-nav"
                onClick={onItemClick}
            >
                Как это работает
            </a>
            <Link
                href="/functions"
                className={getNavItemClass('/functions')}
                onClick={onItemClick}
            >
                Функционал
            </Link>
            <Link
                href="/usage"
                className={getNavItemClass('/usage')}
                onClick={onItemClick}
            >
                Варианты использования
            </Link>
            <Link
                href="/pricing"
                className={getNavItemClass('/pricing')}
                onClick={onItemClick}
            >
                Цены
            </Link>
        </>
    )
}
